module.exports = __webpack_public_path__ + "static/img/Dyson.Heppell.e4f6798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dyson.Heppell.jpg
// module id = RJ76
// module chunks = 0